import script from "./ShopsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopsList.vue?vue&type=script&setup=true&lang=js"

import "./ShopsList.vue?vue&type=style&index=0&id=380b5358&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-380b5358"]])

export default __exports__